<div class="app-input-autocomplete">
  <div class="form-field" style="width: 100%; max-width: 100%">
    <label *ngIf="label" class="app-label"
      >{{ label }}
      <ng-container *ngIf="isRequired">*</ng-container>
      <i
        style="padding-left: 5px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </label>    
    <div class="app-input-autocomplete-field-wrapper">
      <p-autocomplete
        optionLabel="text"
        optionValue="value"
        [formControl]="inputFormControl"
        [suggestions]="filteredOptions$ | async"
        (completeMethod)="onCompleteMethod($event)"
        field="text"
        [forceSelection]="true"
        [minLength]="0"
        [completeOnFocus]="true"
        [delay]="0"
        (onSelect)="updateWithSelection($event)"
        (onClear)="clearField()"
        [placeholder]="placeholder || ('search'|translation)"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="34"
        [autoHighlight]="true"
        [dropdown]="false"
        appendTo="body"
        [baseZIndex]="1000"
      />
    </div>
  </div>
</div>
